"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmbedData = getEmbedData;
exports.getEmbedType = getEmbedType;
exports.validateEmbedUrl = validateEmbedUrl;
exports.validateEmbedHtml = validateEmbedHtml;
exports.defaultValidateEmbed = defaultValidateEmbed;
exports.generateIframeEmbed = generateIframeEmbed;
exports.extractLoadingValue = exports.applyLazyLoadingToEmbed = exports.sanitizeEmbedHtml = exports.convertUrlToEmbedData = exports.matchesWhitelistedEmbedUrl = exports.guessMime = void 0;

var _embed = require("./embed");

var _embed2 = require("../constants/embed");

var _htmlToEmbedData = _interopRequireDefault(require("../utils/htmlToEmbedData"));

var _shared = require("../constants/shared");

var guessMime = function guessMime(url) {
  if (!url) {
    return '';
  }

  url = url.toLowerCase();
  var match = Object.keys(_embed2.supportedMimeTypes).find(function (key) {
    return url.indexOf("." + key) !== -1;
  });
  return match ? _embed2.supportedMimeTypes[match] : '';
};

exports.guessMime = guessMime;

function getEmbedDataFromUrl(url) {
  var urlPattern = _embed2.urlPatterns.find(function (pattern) {
    return pattern.regex.test(url);
  });

  if (!urlPattern) {
    return null;
  }

  var match = urlPattern.regex.exec(url);
  var src = urlPattern.url;
  /* eslint no-loop-func: 0 */

  var _loop = function _loop(i) {
    src = src.replace("$" + i, function () {
      return match[i];
    });
  };

  for (var i = 0; match[i]; i++) {
    _loop(i);
  }

  if (_embed2.queryParamsDefaults[urlPattern.service]) {
    var queryParams = Object.assign({}, _embed2.queryParamsDefaults[urlPattern.service]);

    if (src.indexOf('?') >= 0 && src.length > src.indexOf('?') + 1) {
      var params = src.substring(src.indexOf('?') + 1).split('&');
      src = src.substring(0, src.indexOf('?'));

      for (var _i = 0; params[_i]; _i++) {
        if (params[_i].indexOf('=') >= 0) {
          var paramName = params[_i].substring(0, params[_i].indexOf('='));

          var paramValue = params[_i].substring(params[_i].indexOf('=') + 1);

          queryParams[paramName] = paramValue;
        }
      }
    }

    var queryString = Object.keys(queryParams).map(function (key) {
      return key + "=" + queryParams[key];
    }).join('&');
    src = src + "?" + queryString;
  }

  var data = {
    attributes: [{
      key: 'allowFullScreen',
      value: urlPattern.allowFullscreen
    }, {
      key: 'height',
      value: urlPattern.h
    }, {
      key: 'width',
      value: urlPattern.w
    }, {
      key: 'originalUrl',
      value: url
    }, {
      key: 'service',
      value: urlPattern.service
    }, {
      key: 'src',
      value: src
    }],
    tag: urlPattern.type
  };
  return [data];
}

function getEmbedDataFromHtml(html) {
  if (!html) {
    return null;
  }

  return (0, _htmlToEmbedData.default)(html);
}

function getEmbedData(modalData) {
  if (!modalData) {
    return null;
  }

  if (modalData.url) {
    return getEmbedDataFromUrl(modalData.url);
  }

  return getEmbedDataFromHtml(modalData.embed);
} // Matches: ['https://', 'http://', '//'] and cannot contain whitespace


var EmbedUrlRegex = /^(?:http(?:s)?:)?\/\/[^\s/$.?#].[^\s]*$/; // Checks for valid opening and closing html tags:
// <tag ... /> || <tag>....</tag>
// Optionally start/end with <!-- comment --> tags
// Optionally start with <!--[if ...]> tag and end with <![endif]--> tags

var EmbedHTMLRegex = /^((<!--.+-->)|(<!(--)?\[if.+\]>))?\s*<([a-zA-Z1-6]+)[\w\W]+((\/>)|(<\/([a-zA-Z1-6]+)>)|(<!--.+-->)|(<!\[endif\](--)?>))$/; // Checks if the embed is a URL or an embed code

function getEmbedType(embed) {
  var urlMatch = EmbedUrlRegex.exec(embed);

  if (urlMatch) {
    return _embed2.EmbedFormats.URL;
  }

  var embedMatch = EmbedHTMLRegex.exec(embed);

  if (embedMatch) {
    return _embed2.EmbedFormats.EMBED;
  }

  return null;
}

function validateEmbedUrl(url) {
  return EmbedUrlRegex.test(url);
}

function validateEmbedHtml(html) {
  return EmbedHTMLRegex.test(html);
}

function defaultValidateEmbed(_ref) {
  var url = _ref.url,
      embed = _ref.embed;

  if (url) {
    return validateEmbedUrl(url);
  } else if (embed) {
    return validateEmbedHtml(embed);
  }

  return false;
}

function generateIframeEmbed(data) {
  var allowFullscreen = data.allowFullscreen ? 'allowFullscreen="1"' : '';
  return "<iframe class=\"hs-responsive-embed-iframe\" src=\"" + data.url + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" " + allowFullscreen + " data-service=\"" + data.service + "\"></iframe>";
}

var matchesWhitelistedEmbedUrl = function matchesWhitelistedEmbedUrl(url) {
  if (!_embed2.EXCLUSIVE_EMBED_URL_REGEX.test(url)) return false;
  return _embed2.urlPatterns.find(function (pattern) {
    return pattern.regex.test(url);
  });
};

exports.matchesWhitelistedEmbedUrl = matchesWhitelistedEmbedUrl;

var convertUrlToEmbedData = function convertUrlToEmbedData() {
  var pastedUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var useIframeEmbeds = arguments.length > 1 ? arguments[1] : undefined;
  var url = pastedUrl.trim();

  if (useIframeEmbeds) {
    return EmbedUrlRegex.exec(url) && {
      url: url
    };
  }

  return matchesWhitelistedEmbedUrl(url) && {
    url: url
  };
};

exports.convertUrlToEmbedData = convertUrlToEmbedData;
var fancySingleQuotes = /[\u2018\u2019]/g;
var fancyDoubleQuotes = /[\u201C\u201D]/g;

var sanitizeEmbedHtml = function sanitizeEmbedHtml() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return html.replace(fancySingleQuotes, "'").replace(fancyDoubleQuotes, '"').trim();
};

exports.sanitizeEmbedHtml = sanitizeEmbedHtml;

var applyLazyLoadingToEmbed = function applyLazyLoadingToEmbed(embedCode, lazyLoadingValue) {
  var newEmbedCode = embedCode;
  var value = _shared.LazyLoadingTypes[lazyLoadingValue];
  var newLoading = value ? " loading=\"" + value + "\"" : '';
  var regexMatch = embedCode.match(_embed2.lazyLoadingRegex);
  var oldLoading = regexMatch && regexMatch[1];

  if (oldLoading) {
    newEmbedCode = embedCode.replace(oldLoading, newLoading);
  } else {
    var index = embedCode.indexOf('<iframe') + 7;
    newEmbedCode = embedCode.slice(0, index) + newLoading + embedCode.slice(index);
  }

  return newEmbedCode;
};

exports.applyLazyLoadingToEmbed = applyLazyLoadingToEmbed;

var extractLoadingValue = function extractLoadingValue(embedCode) {
  if ((0, _embed.checkForEmbedScripts)(embedCode) || !embedCode.includes('<iframe')) {
    return undefined;
  }

  var regexMatch = embedCode.match(_embed2.lazyLoadingRegex);
  var lazyLoadingValue = regexMatch && regexMatch[2];
  return Object.keys(_shared.LazyLoadingTypes).find(function (key) {
    return _shared.LazyLoadingTypes[key] === lazyLoadingValue;
  }) || 'default';
};

exports.extractLoadingValue = extractLoadingValue;